import flow from 'lodash/flow';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { deleteBoard } from '../state/actions.tsx';
import {
	getBoard,
	isDeleteInProgress,
	getSprintInformation,
	getOnCancel,
} from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import Content from './content/index.tsx';
import DeleteBoardsModal from './view.tsx';

const mapStateToProps = (state: State) => ({
	Content,
	board: getBoard(state),
	sprintInformation: getSprintInformation(state),
	deleteInProgress: isDeleteInProgress(state),
	onCancel: getOnCancel(state),
});

export default flow(
	injectIntl,
	connect(mapStateToProps, {
		onDelete: deleteBoard,
	}),
)(
	// @ts-expect-error - Argument of type 'typeof DeleteBoardsModal' is not assignable to parameter of type 'ComponentType<{ intl: IntlShapeV2 | IntlShape | undefined; }>'.
	DeleteBoardsModal,
);
